import React from 'react';
import PropTypes from 'prop-types';
import { dispatchControlShape } from 'utils/shapes';
import { Button, CircularProgress } from '@mui/material';
import { AppFormLayout } from '@shared';
import DispatchOrders from './DispatchOrders';

const propTypes = {
  teamOptions: PropTypes.array,
  values: dispatchControlShape.isRequired,
  errors: PropTypes.array, // Assuming errors is an array
  loading: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  handleOrderTrackingChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  timelineBaseURL: PropTypes.string,
  providerName: PropTypes.string,
};

const defaultProps = {};

const DispatchControlSharedUI = ({ values, errors, ...props }) => {

  return (
    <div className="mt16">
      <AppFormLayout>
        <AppFormLayout.Group>
          <DispatchOrders
            orders={values.orders}
            editTracking={values.editTracking}
            handleOrderChange={props.handleOrderTrackingChange}
            uber={props.uber}
            timelineBaseURL={props.timelineBaseURL}
            providerName={props.providerName}
          />
        </AppFormLayout.Group>
        {errors && errors.length > 0 && (
          <AppFormLayout.Group>
            <div style={{ color: 'red' }}>
              <ul>
                {errors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          </AppFormLayout.Group>
)}
        <AppFormLayout.Group>
          <Button
            variant="contained"
            disabled={props.loading}
            startIcon={ props.loading ? <CircularProgress size={16} color="inherit" /> : null }
            onClick={props.handleSubmit}
          >
            {I18n.t("actions.create")}
          </Button>
        </AppFormLayout.Group>
      </AppFormLayout>
    </div>
  );
};

DispatchControlSharedUI.propTypes = propTypes;
DispatchControlSharedUI.defaultProps = defaultProps;

export default DispatchControlSharedUI;
